import { AgTableServer } from "app/shared/AgTable";
import { handleAgCellDataFormat } from "app/shared/AgTable/AgUtility";
import PageHeader from "app/shared/PageHeader";
import React, { useRef, useState, useEffect } from "react";

const TaxOffice = () => {
  const agGridRef = useRef<any>(null);
  const [columnDefs, setColumnDefs] = useState<any[]>([]);



const generateColumnDefs = (data: any[]) => {
  if (!data || data.length === 0) return [];
  const firstRow = data[0];

  return Object.keys(firstRow).map((key) => {
    // Determine format type based on column name
    let formatType = "";

    if (key === "airline_gst_number"||key === "customer_gst_number") formatType = "GSTIN_STATE";
    else if (
      ["cgst_amount", "sgst_amount", "igst_amount", "total_amount"].includes(
        key
      )
    )
      formatType = "AMOUNT";
    else if (
      ["time_stamp_of_processing", "original_invoice_date", "credit_debit_date","airline_invoice_date"].includes(
        key
      )
    )
      formatType = "DATE";

    return {
      headerName: key.replace(/_/g, " ").toUpperCase(),
      field: key,
      filter:
        typeof firstRow[key] === "number"
          ? "agNumberColumnFilter"
          : "agTextColumnFilter",
      enableRowGroup: true,
      enablePivot: true,
      sortable: true,
      resizable: true,
      cellRenderer: (params: any) =>
        handleAgCellDataFormat(
          formatType || params.colDef.formatType,
          params.value,
          params.colDef.formatProps || {},
          params.data
        ),
    };
  });
};








  const onFirstDataRendered = (params: any) => {
    const allRows: any[] = [];
    params.api.forEachNode((node: any) => allRows.push(node.data));

    if (allRows.length > 0) {
      const newDefs = generateColumnDefs(allRows);
      setColumnDefs(newDefs);

      // vvvvv.  force grid to use the new column definitions
      params.api.setColumnDefs(newDefs);
    }
  };

  return (
    <>
      <PageHeader title="Tax Office" />
      <div style={{ flex: 1 }}>
        <AgTableServer
          //@ts-ignore
          columnDefs={columnDefs}
          ref={agGridRef}
          endpoint={"https://stage-apiplatform.finkraftai.com/api/vatTable/getTableData"}
          serverPayload={{ table: "validator_data" }}
          rowData={[]} 
          groupPanel
          defaultPivot={[""]}
          grandTotalRow
          enablePDFViewer
          pinnedBottomRowData
          onFirstDataRendered={onFirstDataRendered}
        />
      </div>
    </>
  );
};

export default TaxOffice;
